import {DEFAULT_EXPORT_TILE_SIZE} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/export/GenogramExportConstants";

export default class GenogramTileGridBuilder {

	buildGrid(bounds, options = {}) {
		let normalizedBounds = this.normalizeBounds(bounds)
		let tileWidth = options.tileWidth || DEFAULT_EXPORT_TILE_SIZE
		let tileHeight = options.tileHeight || tileWidth
		let tiles = []
		let row = 0

		for (let top = normalizedBounds.top; top < normalizedBounds.bottom; top += tileHeight) {
			let currentTileHeight = Math.min(tileHeight, normalizedBounds.bottom - top)
			let column = 0

			for (let left = normalizedBounds.left; left < normalizedBounds.right; left += tileWidth) {
				let currentTileWidth = Math.min(tileWidth, normalizedBounds.right - left)
				tiles.push({
					index: tiles.length,
					row,
					column,
					left,
					top,
					width: currentTileWidth,
					height: currentTileHeight,
				})
				column++
			}

			row++
		}

		return {
			bounds: normalizedBounds,
			tileWidth,
			tileHeight,
			finalWidth: normalizedBounds.width,
			finalHeight: normalizedBounds.height,
			tiles,
		}
	}

	normalizeBounds(bounds = {}) {
		let left = Math.floor(bounds.x1 ?? bounds.left ?? 0)
		let top = Math.floor(bounds.y1 ?? bounds.top ?? 0)
		let rightRaw = bounds.x2 ?? bounds.right ?? left + (bounds.w || 0)
		let bottomRaw = bounds.y2 ?? bounds.bottom ?? top + (bounds.h || 0)
		let right = Math.ceil(rightRaw)
		let bottom = Math.ceil(bottomRaw)
		let width = Math.max(right - left, 0)
		let height = Math.max(bottom - top, 0)

		return {
			left,
			top,
			right,
			bottom,
			width,
			height,
		}
	}
}
